import { Box, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import Subheading from "../../../../components/theme/text/Subheading";
import { tokens } from "../../../../theme";

import OverflowRow from "../../../../components/theme/OverflowRow";

// import { getOrderStatusCounts } from "../../../../api/orders/orders";
import { useTranslation } from 'react-i18next';
import WarehouseLocations from "./Views/WarehouseLocations";


import { endOfMonth, format, startOfMonth } from "date-fns";
import AreaChart from "../../../../components/theme/charts/AreaChart";
import ShDateRangePicker from "../../../../components/theme/ShDateRangePicker";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { useGetDashboardWarehouseLocationChartQuery, useGetDashboardWarehouseLocationTotalsQuery } from "../../../../newapi/warehouse/warehouselocationSlice";
import { warehouseStockLocationsConfig } from "./warehouseStockLocationsConfig";
import { useTopbar } from "../../../../contexts/TopbarProvider";
import { locationChartStates, LocationsPickInUseCard, LocationsPickGradeCard, LocationsBulkInUseCard, LocationsBulkGradeCard } from "./components/LocationsCards";


const TopRow = () => { 
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [chartType, setChartType] = useState(locationChartStates?.revenue);

    const changeChartType = (type) => {
        setChartType(type);
    }

    const currentDate = new Date(); // or any date you want to use

    const [totalsDates, setTotalsDates] =useState({
        startDate : format(startOfMonth(currentDate), 'yyyy-MM-dd'),
        endDate : format(endOfMonth(currentDate), 'yyyy-MM-dd'),
    });

    const [chartDates, setChartDates] =useState({
        startDate : format(startOfMonth(currentDate), 'yyyy-MM-dd'),
        endDate : format(endOfMonth(currentDate), 'yyyy-MM-dd'),
    });

    const [ chartDataData, setChartDataData] = useState([]);

    const { data : totalData, isLoading,isFetching } = useGetDashboardWarehouseLocationTotalsQuery();


    const {data: dashData, isLoading: chartIsLoading, isFetching: chartIsFetching, isError: isChartError, refetch: chartRefetch} = useGetDashboardWarehouseLocationChartQuery({
        type: chartType
    });

    useEffect(() => {
        if (!chartIsLoading && !chartIsFetching && dashData && dashData !== chartDataData) {
            setChartDataData(dashData.data); // Directly store the chart data
        }
    }, [dashData, chartIsLoading, chartIsFetching, chartDataData]);

    // Memoize chart data: directly use the data from the backend
    const chartData = useMemo(() => {
        if (!chartDataData) return []; // Return empty if no chart data is available
        return dashData?.data?.series; // Directly use the series returned by the backend
    }, [chartDataData, dashData]);

    return (
        <OverflowRow>
            <Box
                sx={{
                    // background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    flex:2,
                    // boxShadow: '0px 1px 2px 1px rgba(49, 65, 95, 0.15)',
                    position:"relative", //Needed for absolutely positioned things
                    // width:1,
                    borderRadius:4,
                    display:"flex",
                    gap:3,
                    // "@media screen and (max-width: 47.9375em)" : {
                    //     width: "unset"
                    // }
                }}
            >

                
                        <LocationsPickInUseCard data={totalData} isLoading={isLoading} isFetching={isFetching} />

                        <LocationsPickGradeCard data={totalData} isLoading={isLoading} isFetching={isFetching} />

                        <LocationsBulkInUseCard data={totalData} isLoading={isLoading} isFetching={isFetching} />

                        <LocationsBulkGradeCard data={totalData} isLoading={isLoading} isFetching={isFetching} />
                </Box>
           
            
        </OverflowRow>
    )
}

const StockLocation = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const {showExtraTitle,clearExtraTitle } = useTopbar();

    useEffect(() => {
        showExtraTitle(t("warehouse_locations"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            <TopRow/>

            <TabView3
                tabConfig={warehouseStockLocationsConfig}
                sx={{
                    width:1,
                    background:"green",
                    minHeight:"calc(100% - 431px)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,

                    display:"flex",
                    flexDirection:"column",

                    "&:before" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        left:0,
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition:"250ms"
                    },

                    "&:after" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        right:0,
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform:"scaleX(-1)",
                        transition:"250ms"
                    },

                    "@media screen and (max-width: 47.9375em)" : {
                        "&:after, &:before" : {
                            top:"-0px"
                        }
                    }
                }}
                title={t("outbound")}
                
            >
                <>
                <WarehouseLocations config={warehouseStockLocationsConfig.warehouseLocations}/>

                </>
            </TabView3>
        </Box>
    );
};

export default StockLocation;